import BaseVue from '@/helper/BaseVue';
// import { Vue } from 'vue-property-decorator';
import { Vue, Component } from 'vue-property-decorator';

// // type Constructor<T = {}> = new (...args: any[]) => T;
// // 所有 mixins 都需要
// type Constructor<T = {}> = new (...args: any[]) => T;

// interface EventEmit {
//   slideDown: {}
//   slideUp: {}
// }

// // function isBaseVue(C: Constructor<{}>): C is typeof BaseVue {
// //   return typeof C === 'object';
// // }


// // 添加属性的混合例子
// function BaseMixin<R extends BaseRef = {}, E extends EmitType = {}>(Base: Constructor<any>) {
//   return class extends Base {
//     public $refs: R = {} as any;
//     constructor(...args: any[]) {
//       super(args);
//       const refs = super.$refs;
//       this.$refs = { ...refs as R };
//     }
//     public emit<K extends keyof E>(e: K, ...args: E[K]): this {
//       if (args.length === 0) {
//         super.$emit(e as string, {});
//       } else {
//         super.$emit(e as string, ...args as IArguments);
//       }
//       return this;
//     }
//   };
// }

// class Slide extends BaseMixin<{}, EventEmit>(Vue) { }

// function SlideMixin<T extends typeof Slide>(Base: T) {
//   return class extends Base {
//     public searchFold = false
//     public slideDown() {
//       this.emit('slideDown');
//     }
//     public slideUp() {
//       this.emit('slideUp');
//     }
//   };
// }

// interface EventEmit2 {
//   a: {},
//   b: {},
// }

// class Slide2 extends BaseMixin<{}, EventEmit2>(Vue) { }

// function SlideMixin2<T extends typeof Slide2>(Base: T) {
//   return class extends Base {
//     public searchFold2 = false
//     public slideDown2() {
//       this.emit('a');
//     }
//     public slideUp2() {
//       this.emit('b');
//     }
//   };
// }


// // function SlideMixin2<T>(Base: Constructor<T>) {
// //   return class extends BaseMixin<{}, EventEmit>(Base) {
// //     public searchFold2 = false
// //     public slideDown2() {
// //       this.$emit('slideDown');
// //     }
// //     public slideUp2() {
// //       this.$emit('slideUp');
// //     }
// //   };
// // }


// const SlideMixinExt = SlideMixin2(SlideMixin(BaseMixin(Vue)));

// class C extends SlideMixinExt {
//   public a() {
//     // this.slideDown();
//     // this.slid
//     this.emit('slideUp');
//   }
// }
// // const SlideMixin =


// export default SlideMixin;

@Component
class SlideMixin extends BaseVue {
  public searchFold = false;
  public slideDown() {
    // this.searchFold = true;
    this.$emit('slideDown');
  }
  public slideUp() {
    // this.searchFold = false;
    this.$emit('slideUp');
  }
};

export default SlideMixin;
